import { useCallback } from 'react';

export default function useDispatch(fn, dispatch) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const bindedFunction = useCallback(() => fn(dispatch), [dispatch]);
  return bindedFunction;
}
